<div class="content-container">
  <div class="content-area">
    <div class="landingContent">
      <div class="clr-row">
        <div class="clr-col-lg-7 clr-col-12">
          <div class="welcomeHeading">Welcome</div>
          <div class="welcomeBody">
            CLEAR Safety is an application provided by NYSDOT that is available
            to authorized users for the visualization, query and analysis of NYS
            crash data. The application provides users with pre-configured
            dashboards and reports, as well as robust query functionality
            allowing users to locate, search, visualize and analyze crashes
            using both a tabular grid and interactive map display.
          </div>
          <button
            class="btn btn-primary launchButton"
            (click)="onLaunchClear()"
            [disabled]="
              !systemAvailable || systemAvailable !== 'Healthy' || launchBtn
            "
          >
            <div style="display: flex">
              <div>{{ launchBtn ? 'Launching' : 'Launch' }} CLEAR Safety</div>
              <div [class.hidden]="!launchBtn" style="padding: 5px">
                <span class="spinner spinner-inverse spinner-sm"></span>
              </div>
            </div>
          </button>
          <h6 class="browserHeader">Supported Browsers</h6>
          <div class="flex browserLogoGroup">
            <img
              class="browserLogo"
              src="assets/images/edge_logo.png"
              alt="Edge Logo"
              title="Edge"
            />
            <img
              class="browserLogo"
              src="assets/images/chrome_logo.png"
              alt="Google Chrome Logo"
              title="Chrome"
            />
            <img
              class="browserLogo"
              src="assets/images/firefox_logo.png"
              alt="Firefox Logo"
              title="Firefox"
            />
          </div>
          <p class="resolutionText">
            This site is best viewed at a screen resolution of 1600 x 900 or
            greater.
          </p>
          <p class="dataText">
            This application deals with large amounts of data so it is
            recommended that 64-bit browser versions are used. You may encounter
            problems using 32-bit browsers.
          </p>
        </div>
        <div class="clr-col-lg-5 clr-col-12">
          <div class="appInfoHeading">Application Information</div>
          <ng-container *ngIf="systemAvailable === 'Healthy'">
            <clr-alert [clrAlertType]="'success'" [clrAlertClosable]="false">
              <clr-alert-item>
                <span class="alert-text">
                  The system is currently available
                </span>
              </clr-alert-item>
            </clr-alert>
          </ng-container>
          <ng-container *ngIf="systemAvailable === 'Unhealthy'">
            <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false">
              <clr-alert-item>
                <span class="alert-text">
                  The system is currently unavailable
                </span>
              </clr-alert-item>
            </clr-alert>
          </ng-container>
          <ng-container *ngIf="!systemAvailable">
            <clr-alert [clrAlertType]="'info'" [clrAlertClosable]="false">
              <clr-alert-item>
                <span class="alert-text"> Loading system status... </span>
              </clr-alert-item>
            </clr-alert>
          </ng-container>
          <ng-container>
            <clr-alert [clrAlertType]="'info'" [clrAlertClosable]="false">
              <clr-alert-item>
                <span class="alert-text">
                  System data may be unavailable between 6:00pm and 6:00am due
                  to scheduled data processing
                </span>
              </clr-alert-item>
            </clr-alert>
          </ng-container>
          <div class="recent-updateDiv">
            <h3 class="recent-header">Recent Updates</h3>
            <hr />
            <div class="recent-update-loader" *ngIf="loadRecentUpdates">
              <span class="spinner spinner-sm"></span>
              <span>Loading Recent Clear Safety Updates...</span>
            </div>
            <div *ngIf="!loadRecentUpdates" class="RecentUpdateDiv">
              <div
                *ngIf="RecentUpdates != null && RecentUpdates.length > 0"
                class="recent-updateList"
              >
                <ng-container *ngFor="let updates of RecentUpdates">
                  <clr-alert [clrAlertType]="'info'" [clrAlertClosable]="false">
                    <clr-alert-item>
                      <span class="alert-text">
                        {{ updates.Text }}
                      </span>
                    </clr-alert-item>
                  </clr-alert>
                </ng-container>
              </div>
              <div *ngIf="RecentUpdates != null && RecentUpdates.length == 0">
                <h3>There are no recent updates for Clear Safety</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clr-row footer">
        <div class="clr-col-lg-12 clr-col-12">
          <div class="disclaimerHeader">Disclaimer</div>
          <div class="disclaimerBody">
            WARNING! This application, system and all data contained within are
            the property of New York State. This application or system may
            contain protected personal information and shall only be used for
            purposes authorized by New York State. Unauthorized use or attempted
            unauthorized use of this application is not permitted and may
            subject the user to appropriate disciplinary action and/or
            constitute a federal or state crime. Users (authorized or
            unauthorized) have no explicit or implicit expectation of privacy.
            Any or all uses of this application, system and all data on this
            system may be intercepted, monitored, recorded, copied, audited,
            inspected, and disclosed to authorized State and law enforcement
            personnel, without prior notice. By using this application or
            system, the user consents to these terms and conditions of use as
            well as compliance with the policies and procedures of the State
            Entity that has authorized his/her use.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
